//BadgePage.jsx
import React from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp, faStar, faHeart, faSmile, faCrown } from '@fortawesome/free-solid-svg-icons';
import '../styles/BadgePage.css'; 

const BadgePage = () => {
  const authState = useSelector(state => state.authReducer);
  const user = useSelector(state => state.user);

  // Sample badge data
  const badgeData = [
    { icon: faThumbsUp, data: 135 },
    { icon: faStar, data: 67 },
    { icon: faHeart, data: 178 },
    { icon: faSmile, data: 155 },
    { icon: faCrown, data: 30 },
  ];
  const total = badgeData.reduce((acc, badge) => acc + badge.data, 0);
  const certcount = total/25;
 
  return (
    <div className="table-container" style={{ textAlign: 'center' }}>
      <div>
        <h2>
          {authState.user && authState.user.name
            ? `Hello ${authState.user.name}! Here are the Badges you have earned`
            : 'Hello! Here are the Badges you have earned'}
        </h2>
      </div>
      <table className="icon-table" style={{ textAlign: 'center' }}>
        <thead>
          <tr>
            <th>Icon</th>
            <th>Data</th>
          </tr>
        </thead>
        <tbody>
          {badgeData.map((badge, index) => (
            <tr key={index}>
              <td>
                <FontAwesomeIcon icon={badge.icon} style={{ marginBottom: '5px' }} />
              </td>
              <td>{badge.data}</td>
            </tr>
          ))}
          {/* Total row */}
          <tr style={{ backgroundColor: '#2c3e50', color: 'white' }}>
            <td>Total:</td>
            <td>{total}</td>
          </tr>
        </tbody>
      </table>
      <div>
        <h2>You have earned {Math.floor(certcount)} Certificates.</h2>
        <h3>Rule - For Every 25 Badges You Earn 1 Certificate.</h3>

      </div>

    </div>
  );
};

export default BadgePage;




{
  // import {
  //   faThumbsUp,
  //   faStar,
  //   faHeart,
  //   faCheckCircle,
  //   faMedal,
  //   faAward,
  //   faTrophy,
  //   faSmile,
  //   faCheck,
  //   faStarHalfAlt,
  // } from '@fortawesome/free-solid-svg-icons';  
  /* <div>
<FontAwesomeIcon icon={faThumbsUp} /> Thumbs Up<br />
<FontAwesomeIcon icon={faStar} /> Star<br />
<FontAwesomeIcon icon={faHeart} /> Heart<br />
<FontAwesomeIcon icon={faCheckCircle} /> Check Circle<br />
<FontAwesomeIcon icon={faMedal} /> Medal<br />
<FontAwesomeIcon icon={faAward} /> Award<br />
<FontAwesomeIcon icon={faTrophy} /> Trophy<br />
<FontAwesomeIcon icon={faSmile} /> Smile<br />
<FontAwesomeIcon icon={faCheck} /> Check<br />
<FontAwesomeIcon icon={faStarHalfAlt} /> Star Half<br />
</div> */}
